import { render, staticRenderFns } from "./ClientEditAccount.vue?vue&type=template&id=603c920f&"
import script from "./ClientEditAccount.vue?vue&type=script&lang=js&"
export * from "./ClientEditAccount.vue?vue&type=script&lang=js&"
import style0 from "./ClientEditAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports